'use strict';

// Constructor
var Popular = function() {


};

module.exports = Popular;
